import React from 'react'
import Icon from 'components/Icon'

const FileIcon = ({ filename, ...props }) => {
  if (!filename) {
    return null
  }

  const ext = filename.split('.').pop()

  let icon = 'file'

  if (['docx', 'docm', 'docb'].includes(ext)) {
    icon = 'file-word'
  }

  if (['mp3', 'wav', 'mp4', 'wma', 'aac'].includes(ext)) {
    icon = 'file-music'
  }

  if (['pdf'].includes(ext)) {
    icon = 'file-pdf'
  }

  if (['zip'].includes(ext)) {
    icon = 'file-archive'
  }

  return (
    <Icon icon={['fal', icon]} {...props } />
  )
}

export default FileIcon
